<template>
  <div class="tip">
    <div class="tip-wrapper">
      {{tip}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tip: {
      default: ""
    }
  }
};
</script>
<style scoped>
.tip {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.tip-wrapper {
  width: 300px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  margin: 0 auto;
  text-align: center;
  height: 50px;
  line-height: 50px;
  border-radius: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tip/tip.vue